<template>
  <div style="background: #efeff4;">
    <ph-empty v-if="!dayList.length" />
    <div @click="showPicker = true" class="header-view">
      <div>{{ currentDate }}</div>
      <van-icon name="arrow-down" />
    </div>

    <van-swipe
      ref="swiper"
      :loop="false"
      @change="onDepartmentChange"
      class="daily-list-swipe"
    >
      <van-swipe-item
        v-for="amountInfo in amountList"
        :key="amountInfo.totalCharge"
      >
        <div class="amount-view">
          <div>{{ ftype === "1" ? "门诊" : "住院" }}费用合计</div>
          <div
            style="margin: .5rem;color: black;font-weight: 600;font-size: 2.25rem;"
          >
            {{ amountInfo.totalCharge || amountInfo.totalMoney }}
          </div>
          <div class="amount-info">
            <div>
              医生<span>{{ amountInfo.doctorName }}</span>
            </div>
            <div style="margin-left: 1rem;">
              科室<span>{{ amountInfo.officeName }}</span>
            </div>
          </div>
          <van-icon
            v-if="leftEnable"
            @click="$refs.swiper.prev()"
            name="arrow-left"
            style="position: absolute;top: 40%;left: 1rem;"
          />
          <van-icon
            v-if="rightEnable"
            @click="$refs.swiper.next()"
            name="arrow"
            style="position: absolute;top: 40%;right: 1rem;"
          />
        </div>
      </van-swipe-item>
    </van-swipe>

    <div class="content-view">
      <div v-if="ftype === '2'">
        <div
          v-for="(item, index) in detailList"
          :key="index"
          class="inpatient-detail"
        >
          <div style="color: black;font-size: 1rem;">
            <span>{{ item.typeName }}</span>
            <span style="float: right;">{{ item.total }}</span>
          </div>
          <div
            v-for="(detail, detailIndex) in item.detailList"
            :key="detailIndex"
          >
            <div style="margin-top: .5rem;color: #3f3f3f;font-size: .9rem;">
              <span>{{ detail.itemName }}</span>
            </div>
            <div>类型：{{ detail.itemType }}</div>
            <div>编码：{{ detail.itemCode }}</div>
            <div>数量/单位：{{ detail.amount }}/{{ detail.itemUnit }}</div>
            <div>单价：￥{{ detail.unitPrice }}</div>
            <div>合计：￥{{ detail.totalAmount }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="(item, index) in detailList" :key="index">
          <div style="color: black;font-size: 1rem;">
            <span>{{ item.itemName }}</span>
          </div>
          <div>规格：{{ item.xmspm0 }}</div>
          <div>编码：{{ item.itemCode }}</div>
          <div>数量/单位：{{ item.itemAmount }}/{{ item.itemUnit }}</div>
          <div>单价：￥{{ item.itemPrice }}</div>
          <div>合计：￥{{ item.itemTotalAmount }}</div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="showPicker"
      closeable
      close-icon="close"
      position="bottom"
    >
      <div style="margin: 2rem 1rem 1rem 1rem;">日期选择</div>
      <div class="date-select-list">
        <div
          v-for="(item, index) in dayList"
          :key="index"
          :class="currentItem == index ? 'selected' : ''"
          @click="selectDate(index)"
        >
          {{ item.chargeDate.replace(/(.{4})(.{2})(.{2})/, "$1.$2.$3") }}
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPicker: false,
      currentItem: 0,
      dayList: [],
      detailList: [],
      ftype: "1",
      currentIndicator: 0
    };
  },
  computed: {
    currentDate() {
      if (this.dayList.length > this.currentItem) {
        return this.dayList[this.currentItem].chargeDate.replace(
          /(.{4})(.{2})(.{2})/,
          "$1年$2月$3日"
        );
      }
      return "";
    },
    amountList() {
      if (
        this.dayList.length > this.currentItem &&
        this.dayList[this.currentItem].daylist.length
      ) {
        return this.dayList[this.currentItem].daylist;
      }
      return [];
    },
    leftEnable() {
      return this.amountList.length > 0 && this.currentIndicator > 0;
    },
    rightEnable() {
      return (
        this.amountList.length > 0 &&
        this.currentIndicator < this.amountList.length - 1
      );
    }
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    this.getDailyListDates();
  },
  methods: {
    onDepartmentChange(index) {
      this.currentIndicator = index;
      if (this.ftype === "1") {
        this.getDailyListDetail(
          this.amountList[index].chargeSerialNo,
          this.amountList[index].outpatientNo
        );
      } else {
        this.getInpatientDailyListDetail(this.amountList[index]);
      }
    },
    getDailyListDates() {
      this.$http
        .post(this.$api.REPORT_DAILYLIST_DATE, {
          functionType: this.ftype
        })
        .then(res => {
          this.dayList = res;
          if (res.length) {
            if (this.ftype === "1") {
              this.getDailyListDetail(
                res[0].daylist[0].chargeSerialNo,
                res[0].daylist[0].outpatientNo
              );
            } else {
              this.getInpatientDailyListDetail(res[0]);
            }
          }
        });
    },
    getDailyListDetail(chargeSerialNo, outpatientNo) {
      this.$http
        .post(this.$api.REPORT_DAILYLIST_DETAIL, {
          functionType: this.ftype,
          chargeSerialNo: chargeSerialNo,
          outpatientNo: outpatientNo
        })
        .then(res => {
          this.detailList = res;
        });
    },
    getInpatientDailyListDetail(date) {
      this.$http
        .post(this.$api.REPORT_INPATIENT_DAILYLIST_DETAIL, {
          functionType: this.ftype,
          chargeDate: date.chargeDate
        })
        .then(res => {
          this.detailList = res;
        });
    },
    selectDate(index) {
      this.currentIndicator = 0;
      this.showPicker = false;
      this.currentItem = index;
      if (this.ftype === "1") {
        this.getDailyListDetail(
          this.dayList[index].daylist[0].chargeSerialNo,
          this.dayList[index].daylist[0].outpatientNo
        );
      } else {
        this.getInpatientDailyListDetail(this.dayList[index]);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.header-view {
  position: relative;
  display: flex;
  align-items: center;
  margin: 1rem 1rem 0 1rem;
  padding: 1rem;
  color: white;
  background: #108eee;
  border-radius: 0.5rem 0.5rem 0 0;

  div {
    margin: auto;
  }

  i {
    position: absolute;
    right: 20%;
  }
}

.amount-view {
  position: relative;
  height: 8rem;
  margin: 0 1rem;
  padding: 1rem;
  color: gray;
  text-align: center;
  background: white;
  border-radius: 0.5rem;

  .amount-info {
    display: flex;
    justify-content: center;
    font-size: 0.88rem;

    span {
      margin-left: 0.5rem;
      color: black;
    }
  }
}
.content-view {
  margin: 0 1rem;
  margin-top: 2px;
  background: white;
  border-radius: 0.5rem;
  > div {
    padding: 1rem;
    color: gray;
    font-size: 0.85rem;
    border-bottom: 1px solid #f4f4f4;
  }

  .inpatient-detail {
    margin-top: 0.88rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #efeff4;
  }
}

.date-select-list {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  // padding: 1rem;

  .selected {
    color: white;
    background-color: #6596f2;
    border: none;
  }

  div {
    width: 30%;
    margin-bottom: 0.5rem;
    margin-left: 0.5rem;
    color: black;
    line-height: 2rem;
    text-align: center;
    border: solid 1px #dcdcdc;
    border-radius: 0.2rem;
  }
}
</style>

<style lang="less">
.daily-list-swipe .van-swipe__indicator {
  background-color: black;
}
.daily-list-swipe .van-swipe__indicator--active {
  background-color: @primary-blue;
}
</style>
